var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "header-controls", attrs: { id: "header__controls" } },
    [
      _c(
        "b-modal",
        {
          attrs: {
            centered: "",
            "hide-footer": "",
            id: "feedbackModal",
            title: "Send Feedback"
          }
        },
        [_c("FeedbackModal", { ref: "refFeedbackModal" })],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-7 col-md-8 col-8 left-side" }, [
            _vm.$router.currentRoute.name == "globalAlert"
              ? _c(
                  "div",
                  { staticClass: "form-inline" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "header-filter-btns",
                        attrs: { variant: "theme" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("createNewAlert")
                          }
                        }
                      },
                      [
                        _vm._v("\n            Add Alert\n            "),
                        _c("i", {
                          staticClass: "fas text-primary fa-plus fa-fw"
                        })
                      ]
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.$router.currentRoute.name != "permissionManager" &&
            _vm.$router.currentRoute.name != "globalAlert" &&
            _vm.$router.currentRoute.name != "userGlobalAlert"
              ? _c(
                  "div",
                  {
                    class:
                      "form-inline " +
                      (_vm.$router.currentRoute.name == "dashboard" ||
                      _vm.$router.currentRoute.name == "myWeek"
                        ? "deliverableTemplate-filter-form"
                        : "")
                  },
                  [
                    _c("div", { staticClass: "input-group top-search" }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.searchQuery,
                            expression: "searchQuery"
                          },
                          {
                            name: "debounce",
                            rawName: "v-debounce:500ms",
                            value: _vm.setQuery,
                            expression: "setQuery",
                            arg: "500ms"
                          }
                        ],
                        ref: "searchQuery",
                        staticClass: "form-control",
                        class:
                          _vm.$router.currentRoute.name == "globalSearch"
                            ? ""
                            : "media-calls-search",
                        attrs: {
                          type: "text",
                          "debounce-events": ["keyup"],
                          placeholder: _vm.querySearchPlaceHolder,
                          id: "search-query"
                        },
                        domProps: { value: _vm.searchQuery },
                        on: {
                          click: function($event) {
                            return _vm.$refs.searchQuery.select()
                          },
                          keypress: function($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            ) {
                              return null
                            }
                            return _vm.triggerSearch.apply(null, arguments)
                          },
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.searchQuery = $event.target.value
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "input-group-append cursor-pointer",
                          on: { click: _vm.triggerSearch }
                        },
                        [_vm._m(0)]
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "b-popover",
                      {
                        ref: "popover",
                        attrs: {
                          triggers: "click blur",
                          boundary: "window",
                          placement: "bottom",
                          target: "popover-button-event",
                          "custom-class": "deliverableTemplate-filter"
                        }
                      },
                      [
                        _c("div", { staticClass: "d-flex flex-row" }, [
                          _c(
                            "div",
                            { staticClass: "filter-item item__status" },
                            [
                              _c("label", {
                                domProps: {
                                  innerHTML: _vm._s(_vm.getCalendarStatusLabel)
                                }
                              }),
                              _vm._v(" "),
                              !_vm.isMobile()
                                ? _c(
                                    "div",
                                    { staticClass: "status-wrap" },
                                    _vm._l(_vm.statuses, function(s, index) {
                                      return _c(
                                        "a",
                                        {
                                          key: index,
                                          staticClass: "badge mr-2",
                                          style: {
                                            color: "var(--wf-secondary)",
                                            backgroundColor: s.color
                                          },
                                          attrs: { href: "#" },
                                          on: {
                                            click: function($event) {
                                              return _vm.setStatusFilter(s)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(s.name))]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "custom-field status-field" },
                                [
                                  _vm.isMobile()
                                    ? _c("multiselect", {
                                        attrs: {
                                          searchable: true,
                                          label: "name",
                                          options: _vm.statuses,
                                          placeholder: "Select status",
                                          "show-labels": false,
                                          multiple: true,
                                          "hide-selected": true
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "option",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color:
                                                          "var(--wf-secondary)",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        height: "40px",
                                                        lineHeight: "40px",
                                                        textAlign: "center"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            },
                                            {
                                              key: "tag",
                                              fn: function(props) {
                                                return [
                                                  _c(
                                                    "div",
                                                    {
                                                      style: {
                                                        color:
                                                          "var(--wf-secondary)",
                                                        borderRadius: "10px",
                                                        backgroundColor:
                                                          props.option.color,
                                                        textAlign: "center",
                                                        display: "inline-block",
                                                        padding: "5px 10px",
                                                        marginRight: "5px"
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          props.option.name
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          1936226673
                                        ),
                                        model: {
                                          value: _vm.filterQuery.status,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "status",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.status"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _vm.checkCalendarMode([
                              "deliverableTemplates",
                              "tasks"
                            ])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__outlet" },
                                  [
                                    _c(
                                      "div",
                                      [
                                        _c("label", [_vm._v("Outlet")]),
                                        _vm._v(" "),
                                        _vm.isMobile()
                                          ? _c(
                                              "b-form-checkbox",
                                              {
                                                staticClass:
                                                  "float-right csm-checkbox",
                                                attrs: {
                                                  id: "no-outlet",
                                                  name: "no-outlet",
                                                  value: "accepted",
                                                  "unchecked-value":
                                                    "not_accepted"
                                                },
                                                on: {
                                                  input: function($event) {
                                                    _vm.filterQuery.noOutlet ==
                                                    "accepted"
                                                      ? (_vm.filterQuery.outlet = [])
                                                      : ""
                                                  }
                                                },
                                                model: {
                                                  value:
                                                    _vm.filterQuery.noOutlet,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.filterQuery,
                                                      "noOutlet",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "filterQuery.noOutlet"
                                                }
                                              },
                                              [_vm._v("No Outlet")]
                                            )
                                          : _vm._e()
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "outlet-wrap" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            ref: "outletFilter",
                                            attrs: {
                                              "track-by": "id",
                                              "open-direction": "bottom",
                                              label: "name",
                                              options: _vm.contacts,
                                              "show-labels": false,
                                              multiple: true,
                                              "close-on-select": false,
                                              "hide-selected": true,
                                              "preserve-search": true,
                                              "clear-on-select": false,
                                              "internal-search": false,
                                              loading: _vm.isContactsLoading
                                            },
                                            on: {
                                              select: function($event) {
                                                _vm.filterQuery.noOutlet =
                                                  "not_accepted"
                                              },
                                              "search-change": _vm.onWhoSearch
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var values = ref.values
                                                    var search = ref.search
                                                    var isOpen = ref.isOpen
                                                    return [
                                                      values.length && !isOpen
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiselect__single"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  values.length
                                                                ) +
                                                                  " options selected"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                },
                                                {
                                                  key: "option",
                                                  fn: function(props) {
                                                    return [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "option__desc"
                                                        },
                                                        [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option__title"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .name
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _vm._v(" "),
                                                          _c("br"),
                                                          _vm._v(" "),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "option__small text-muted"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.option
                                                                    .company_name
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              3293270324
                                            ),
                                            model: {
                                              value: _vm.filterQuery.outlet,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "outlet",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.outlet"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noOptions" },
                                              [
                                                _vm._v(
                                                  "Start typing to find contacts."
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noResult" },
                                              [
                                                _vm._v(
                                                  "No results. Please try changing the search query."
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    !_vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass: "mt-2 csm-checkbox",
                                            attrs: {
                                              id: "no-outlet",
                                              name: "no-outlet",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.filterQuery.noOutlet ==
                                                "accepted"
                                                  ? (_vm.filterQuery.outlet = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value: _vm.filterQuery.noOutlet,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "noOutlet",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.noOutlet"
                                            }
                                          },
                                          [_vm._v("No Outlet")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "filter-item item__coordinator" },
                              [
                                _c("label", [_vm._v("Assigned To")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "coordinator-wrap" },
                                  [
                                    _c("multiselect", {
                                      ref: "coordinatorFilter",
                                      attrs: {
                                        options: _vm.allActiveUsers,
                                        "show-labels": false,
                                        multiple: true,
                                        "open-direction": "bottom",
                                        label: "name",
                                        "track-by": "id",
                                        "hide-selected": true,
                                        "close-on-select": false,
                                        "clear-on-select": false
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "selection",
                                            fn: function(ref) {
                                              var values = ref.values
                                              var search = ref.search
                                              var isOpen = ref.isOpen
                                              return [
                                                values.length && !isOpen
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "multiselect__single"
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            values.length
                                                          ) +
                                                            " options selected"
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        249740006
                                      ),
                                      model: {
                                        value: _vm.filterQuery.coordinator,
                                        callback: function($$v) {
                                          _vm.$set(
                                            _vm.filterQuery,
                                            "coordinator",
                                            $$v
                                          )
                                        },
                                        expression: "filterQuery.coordinator"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.$router.currentRoute.name != "globalSearch" &&
                            _vm.$router.currentRoute.name != "mediaCallPage" &&
                            _vm.checkCalendarMode([
                              "deliverableTemplates",
                              "tasks"
                            ])
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "filter-item item__deliverableTemplate__type"
                                  },
                                  [
                                    _c("label", [
                                      _vm._v("DeliverableTemplate Type")
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "deliverableTemplate-type-wrap"
                                      },
                                      [
                                        _c("multiselect", {
                                          ref: "deliverableTemplateFilter",
                                          attrs: {
                                            options: _vm.deliverableTemplate,
                                            "show-labels": false,
                                            multiple: true,
                                            "open-direction": "bottom",
                                            label: "name",
                                            "track-by": "id",
                                            "hide-selected": true,
                                            "close-on-select": false,
                                            "clear-on-select": false
                                          },
                                          model: {
                                            value:
                                              _vm.filterQuery
                                                .deliverableTemplate,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterQuery,
                                                "deliverableTemplate",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "filterQuery.deliverableTemplate"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "grouped-filter-item" }, [
                            _c(
                              "div",
                              { staticClass: "filter-item item__department" },
                              [
                                _c(
                                  "div",
                                  [
                                    _c("label", [_vm._v("Department")]),
                                    _vm._v(" "),
                                    _vm.isMobile()
                                      ? _c(
                                          "b-form-checkbox",
                                          {
                                            staticClass:
                                              "float-right csm-checkbox",
                                            attrs: {
                                              id: "no-department",
                                              name: "no-department",
                                              value: "accepted",
                                              "unchecked-value": "not_accepted"
                                            },
                                            on: {
                                              input: function($event) {
                                                _vm.filterQuery.noDepartment ==
                                                "accepted"
                                                  ? (_vm.filterQuery.department = [])
                                                  : ""
                                              }
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery.noDepartment,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "noDepartment",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.noDepartment"
                                            }
                                          },
                                          [_vm._v("No Department")]
                                        )
                                      : _vm._e()
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "tag-wrap" },
                                  [
                                    _c(
                                      "multiselect",
                                      {
                                        ref: "departmentFilter",
                                        attrs: {
                                          "open-direction": "bottom",
                                          label: "name",
                                          "track-by": "id",
                                          options: _vm.allActiveDepartments,
                                          "hide-selected": true,
                                          "show-labels": false,
                                          multiple: true,
                                          "close-on-select": false,
                                          "clear-on-select": false
                                        },
                                        on: {
                                          select: function($event) {
                                            _vm.filterQuery.noDepartment =
                                              "not_accepted"
                                          }
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "selection",
                                              fn: function(ref) {
                                                var values = ref.values
                                                var search = ref.search
                                                var isOpen = ref.isOpen
                                                return [
                                                  values.length && !isOpen
                                                    ? _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "multiselect__single"
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              values.length
                                                            ) +
                                                              " options selected"
                                                          )
                                                        ]
                                                      )
                                                    : _vm._e()
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          249740006
                                        ),
                                        model: {
                                          value: _vm.filterQuery.department,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "department",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.department"
                                        }
                                      },
                                      [
                                        _vm._v(" "),
                                        _c("template", { slot: "noOptions" }, [
                                          _vm._v(
                                            "Start typing to find departments."
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("template", { slot: "noResult" }, [
                                          _vm._v(
                                            "No results. Please try changing the search query."
                                          )
                                        ])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                !_vm.isMobile()
                                  ? _c(
                                      "b-form-checkbox",
                                      {
                                        staticClass: "mt-2 csm-checkbox",
                                        attrs: {
                                          id: "no-department",
                                          name: "no-department",
                                          value: "accepted",
                                          "unchecked-value": "not_accepted"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.filterQuery.noDepartment ==
                                            "accepted"
                                              ? (_vm.filterQuery.department = [])
                                              : ""
                                          }
                                        },
                                        model: {
                                          value: _vm.filterQuery.noDepartment,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "noDepartment",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.noDepartment"
                                        }
                                      },
                                      [_vm._v("No Department")]
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.checkCalendarMode([
                              "deliverableTemplates",
                              "tasks"
                            ])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__tag" },
                                  [
                                    _c("label", [_vm._v("Tag")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tag-wrap" },
                                      [
                                        _c(
                                          "multiselect",
                                          {
                                            ref: "tagFilter",
                                            attrs: {
                                              options: _vm.tags,
                                              "show-labels": false,
                                              multiple: true,
                                              "open-direction": "bottom",
                                              label: "name",
                                              "track-by": "id",
                                              "hide-selected": true,
                                              "close-on-select": false,
                                              "clear-on-select": false,
                                              loading: _vm.isTagsLoading,
                                              "preserve-search": true
                                            },
                                            on: {
                                              "search-change": _vm.onTagSearch
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "selection",
                                                  fn: function(ref) {
                                                    var values = ref.values
                                                    var search = ref.search
                                                    var isOpen = ref.isOpen
                                                    return [
                                                      values.length && !isOpen
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "multiselect__single"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  values.length
                                                                ) +
                                                                  " options selected"
                                                              )
                                                            ]
                                                          )
                                                        : _vm._e()
                                                    ]
                                                  }
                                                }
                                              ],
                                              null,
                                              false,
                                              249740006
                                            ),
                                            model: {
                                              value: _vm.filterQuery.tag,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "tag",
                                                  $$v
                                                )
                                              },
                                              expression: "filterQuery.tag"
                                            }
                                          },
                                          [
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noOptions" },
                                              [
                                                _vm._v(
                                                  "Start typing to find tags."
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "template",
                                              { slot: "noResult" },
                                              [
                                                _vm._v(
                                                  "No results. Please try changing the search query."
                                                )
                                              ]
                                            )
                                          ],
                                          2
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.checkCalendarMode([
                              "deliverableTemplates",
                              "tasks"
                            ])
                              ? _c(
                                  "div",
                                  { staticClass: "filter-item item__project" },
                                  [
                                    _c("label", [_vm._v("Project")]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "project-wrap" },
                                      [
                                        _c("multiselect", {
                                          ref: "projectFilter",
                                          attrs: {
                                            options: _vm.allProjects,
                                            "show-labels": false,
                                            multiple: true,
                                            "open-direction": "bottom",
                                            label: "title",
                                            "track-by": "id",
                                            "hide-selected": true,
                                            "close-on-select": false,
                                            "clear-on-select": false,
                                            "preserve-search": true
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "selection",
                                                fn: function(ref) {
                                                  var values = ref.values
                                                  var search = ref.search
                                                  var isOpen = ref.isOpen
                                                  return [
                                                    values.length && !isOpen
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "multiselect__single"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                values.length
                                                              ) +
                                                                " options selected"
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ]
                                                }
                                              }
                                            ],
                                            null,
                                            false,
                                            249740006
                                          ),
                                          model: {
                                            value: _vm.filterQuery.project,
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.filterQuery,
                                                "project",
                                                $$v
                                              )
                                            },
                                            expression: "filterQuery.project"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "filter-item item__date",
                              class: {
                                "filter-item-no-border":
                                  _vm.$router.currentRoute.name == "calendar"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "due__created__dates" },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c("label", [
                                        _vm._v(_vm._s(_vm.dueDateLabel))
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "picker",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customDueDateRanges
                                        },
                                        on: { update: _vm.onUpdateDueDate },
                                        model: {
                                          value: _vm.filterQuery.dateRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateRange",
                                              $$v
                                            )
                                          },
                                          expression: "filterQuery.dateRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.$router.currentRoute.name ==
                                    "dashboard" ||
                                  _vm.$router.currentRoute.name == "myWeek"
                                    ? _c(
                                        "div",
                                        [
                                          _c("label", { staticClass: "mt-2" }, [
                                            _vm._v("Task Due Date")
                                          ]),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("date-range-picker", {
                                            ref: "picker",
                                            attrs: {
                                              autoApply: true,
                                              ranges: _vm.customDueDateRanges
                                            },
                                            on: {
                                              update: _vm.onUpdateTaskDueDate
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery.taskDateRange,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "taskDateRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.taskDateRange"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c("label", { staticClass: "mt-2" }, [
                                        _vm._v("Created")
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("date-range-picker", {
                                        ref: "pickerDateCreated",
                                        attrs: {
                                          autoApply: true,
                                          ranges: _vm.customCreatedDateRanges
                                        },
                                        on: { update: _vm.onUpdateDateCreated },
                                        model: {
                                          value:
                                            _vm.filterQuery.dateCreatedRange,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.filterQuery,
                                              "dateCreatedRange",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "filterQuery.dateCreatedRange"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.checkCalendarMode([
                                    "deliverableTemplates",
                                    "tasks"
                                  ])
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "label",
                                            { staticClass: "mt-lg-2" },
                                            [_vm._v("Completed")]
                                          ),
                                          _vm._v(" "),
                                          _c("br"),
                                          _vm._v(" "),
                                          _c("date-range-picker", {
                                            ref: "pickerDateCompleted",
                                            attrs: {
                                              autoApply: true,
                                              ranges:
                                                _vm.customCompletedDateRanges
                                            },
                                            on: {
                                              update: _vm.onUpdateDateCompleted
                                            },
                                            model: {
                                              value:
                                                _vm.filterQuery
                                                  .dateCompletedRange,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.filterQuery,
                                                  "dateCompletedRange",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "filterQuery.dateCompletedRange"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _vm.checkCalendarMode([
                            "deliverableTemplates",
                            "tasks"
                          ])
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "filter-item item__priority filter-item-no-border"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "priority__filter" },
                                    [
                                      _c("label", [_vm._v("Priority")]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "filter-rating",
                                          on: { click: _vm.setPriority }
                                        },
                                        [
                                          _c("vue-star-rate", {
                                            attrs: {
                                              rateRange:
                                                _vm.filterQuery.priorityFilter,
                                              maxIcon: 5,
                                              iconHeight: 17,
                                              iconWidth: 17,
                                              hasCounter: false,
                                              iconColor: "var(--wf-primary)",
                                              iconColorHover:
                                                "var(--wf-primary)",
                                              iconShape: "circle"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "priority__sort" }, [
                                    _c("label", { staticClass: "mt-2" }, [
                                      _vm._v("Sort by Priority")
                                    ]),
                                    _vm._v(" "),
                                    _c("br"),
                                    _vm._v(" "),
                                    _vm.$router.currentRoute.name !=
                                    "globalSearch"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "btn-group add-new__global_search sorting main__filter"
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-theme header-filter-btns dropdown-toggle",
                                                attrs: {
                                                  type: "button",
                                                  "data-toggle": "dropdown",
                                                  "aria-haspopup": "true",
                                                  "aria-expanded": "false"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      Sort\n                      "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "fas fa-sort text-primary float-right"
                                                })
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "dropdown-menu" },
                                              [
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setSort(
                                                          "priorityDesc"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Priority Decending")]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "dropdown-item",
                                                    attrs: { href: "#" },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.setSort(
                                                          "priorityAsc"
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [_vm._v("Priority Ascending")]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ])
                                ]
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c("div", [
                            _c(
                              "div",
                              { staticClass: "item__reset" },
                              [
                                _c(
                                  "b-button",
                                  {
                                    attrs: {
                                      variant: "theme",
                                      title: "Reset All Filter",
                                      size: "sm"
                                    },
                                    on: { click: _vm.resetFilter }
                                  },
                                  [_c("i", { staticClass: "fas fa-undo" })]
                                ),
                                _vm._v(" "),
                                _c(
                                  "b-button",
                                  {
                                    staticClass: "d-block d-lg-none",
                                    attrs: {
                                      variant: "theme",
                                      title: "Close Filter Popup",
                                      size: "sm"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.$refs.popover.$emit("close")
                                      }
                                    }
                                  },
                                  [_c("i", { staticClass: "fas fa-times" })]
                                )
                              ],
                              1
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.isFilterActive(),
                                expression: "isFilterActive()"
                              }
                            ],
                            key: "filterKey" + _vm.reloadCounter,
                            staticClass: "d-none d-md-block mt-3 test1"
                          },
                          [
                            _c("label", [_vm._v("Click to remove filters :")]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c(
                              "span",
                              {
                                staticClass: "badge badge-primary mr-2 mb-2",
                                style: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    _vm.filterQuery.query = null
                                    _vm.searchQuery = ""
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.filterQuery.query))]
                            ),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.status, function(status) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge mr-2 mb-2",
                                  style: {
                                    cursor: "pointer",
                                    color: "var(--wf-secondary)",
                                    backgroundColor: status.color
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(status)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(status.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.outlet, function(outlet) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(outlet)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(outlet.name))]
                              )
                            }),
                            _vm._v(" "),
                            Array.isArray(_vm.filterQuery.deliverableTemplate)
                              ? _c(
                                  "span",
                                  _vm._l(
                                    _vm.filterQuery.deliverableTemplate,
                                    function(deliverableTemplate) {
                                      return _c(
                                        "span",
                                        {
                                          staticClass:
                                            "badge badge-primary mr-2 mb-2",
                                          style: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeFilter(
                                                deliverableTemplate
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(deliverableTemplate.name)
                                          )
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : typeof _vm.filterQuery.deliverableTemplate !=
                                "undefined"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "deliverableTemplate"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterQuery.deliverableTemplate.name
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.priorityFilter > 0
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "resetPriorityFilter"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Priority " +
                                        _vm._s(_vm.filterQuery.priorityFilter)
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$router.currentRoute.name != "globalSearch" &&
                            _vm.filterQuery.sort
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge mr-2 mb-2 bg-primary cursor-pointer",
                                    staticStyle: {
                                      color: "var(--wf-secondary)"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "resetDeliverableTemplateSort"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.filterQuery.sort == "priorityDesc"
                                          ? "Priority Descending"
                                          : "Priority Ascending"
                                      )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.coordinator, function(
                              coordinator
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(coordinator)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(coordinator.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter("filterByDate")
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.dueDateLabel) +
                                        ": " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateRange.startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateRange.endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByTaskDate
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByTaskDate"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Task Due Date: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.taskDateRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.taskDateRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterNoDueDate == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.filterNoDueDate = false
                                      }
                                    }
                                  },
                                  [_vm._v("No " + _vm._s(_vm.dueDateLabel))]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterNoTaskDueDate == 1
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.filterNoTaskDueDate = false
                                      }
                                    }
                                  },
                                  [_vm._v("No Task Due Date")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDateCreated
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByDateCreated"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Created: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCreatedRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCreatedRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.filterByDateCompleted
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFilter(
                                          "filterByDateCompleted"
                                        )
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "Completed: " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCompletedRange
                                              .startDate,
                                            "MMM DD"
                                          )
                                        ) +
                                        " - " +
                                        _vm._s(
                                          _vm._f("moment")(
                                            _vm.filterQuery.dateCompletedRange
                                              .endDate,
                                            "MMM DD"
                                          )
                                        )
                                    )
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.tag, function(tag) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(tag)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(tag.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.department, function(
                              department
                            ) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(department)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(department.name))]
                              )
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filterQuery.project, function(project) {
                              return _c(
                                "span",
                                {
                                  staticClass: "badge badge-primary mr-2 mb-2",
                                  style: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      return _vm.removeFilter(project)
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(project.title))]
                              )
                            }),
                            _vm._v(" "),
                            _vm.filterQuery.noDepartment == "accepted"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.noDepartment =
                                          "not_accepted"
                                      }
                                    }
                                  },
                                  [_vm._v("No Department")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.filterQuery.noOutlet == "accepted"
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "badge badge-primary mr-2 mb-2",
                                    style: { cursor: "pointer" },
                                    on: {
                                      click: function($event) {
                                        _vm.filterQuery.noOutlet =
                                          "not_accepted"
                                      }
                                    }
                                  },
                                  [_vm._v("No Outlet")]
                                )
                              : _vm._e()
                          ],
                          2
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "calendar"
                      ? _c(
                          "div",
                          { staticClass: "ml-2 calendar-type-control" },
                          [
                            _c(
                              "label",
                              { staticClass: "btn-theme date-filter-triggers" },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "deliverableTemplates",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "deliverableTemplates",
                                      value: "deliverableTemplates",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode(
                                          "deliverableTemplates"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                DeliverableTemplates\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass:
                                  "btn-theme ml-2 date-filter-triggers"
                              },
                              [
                                _c(
                                  "b-form-radio",
                                  {
                                    ref: "projects",
                                    staticClass: "csm-checkbox",
                                    attrs: {
                                      id: "projects",
                                      value: "projects",
                                      name: "dataSetTypeTrigger"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.changeCalendarMode(
                                          "projects"
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.dataSetType,
                                      callback: function($$v) {
                                        _vm.dataSetType = $$v
                                      },
                                      expression: "dataSetType"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n                Projects\n              "
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch" &&
                    _vm.$router.currentRoute.name != "calendar" &&
                    _vm.$router.currentRoute.name != "mediaCallPage" &&
                    _vm.$router.currentRoute.name != "socialMedia"
                      ? _c(
                          "div",
                          { staticClass: "new-deliverableTemplates ml-2" },
                          [
                            _c(
                              "div",
                              { staticClass: "btn-group wider-filter-only" },
                              [
                                _vm.hasMultipleDeliverableTemplate
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn-theme btn-split-button header-filter-btns",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "New " +
                                            _vm._s(
                                              _vm.getBaseDeliverableTemplate()
                                            )
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "fas text-primary float-right fa-plus fa-fw"
                                        })
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasMultipleDeliverableTemplate
                                  ? _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn-theme dropdown-toggle dropdown-toggle-split btn-split-button",
                                        attrs: {
                                          type: "button",
                                          "data-toggle": "dropdown",
                                          "aria-expanded": "false"
                                        }
                                      },
                                      [
                                        _c("span", { staticClass: "sr-only" }, [
                                          _vm._v("Toggle Dropdown")
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "dropdown-menu dropdown-menu-right"
                                  },
                                  _vm._l(_vm.newDeliverableTemplates, function(
                                    type,
                                    i
                                  ) {
                                    return _c(
                                      "a",
                                      {
                                        key: i,
                                        staticClass: "dropdown-item",
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.createDeliverableTemplateDropdownClick(
                                              type
                                            )
                                          }
                                        }
                                      },
                                      [_vm._v(_vm._s(type.title))]
                                    )
                                  }),
                                  0
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "mobile-filter-only" }, [
                              _vm.hasMultipleDeliverableTemplate
                                ? _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-theme header-filter-btns dropdown-toggle",
                                      attrs: {
                                        type: "button",
                                        "data-toggle": "dropdown",
                                        "aria-expanded": "false"
                                      }
                                    },
                                    [
                                      _vm._v("New "),
                                      _c("i", {
                                        staticClass:
                                          "fas text-primary float-right fa-plus fa-fw",
                                        staticStyle: { "margin-left": "10px" }
                                      })
                                    ]
                                  )
                                : _c(
                                    "button",
                                    {
                                      staticClass:
                                        "btn btn-theme header-filter-btns",
                                      attrs: { type: "button" },
                                      on: {
                                        click: function($event) {
                                          return _vm.createNewDeliverableTemplateFromId()
                                        }
                                      }
                                    },
                                    [
                                      _vm._v("New "),
                                      _c("i", {
                                        staticClass:
                                          "fas text-primary float-right fa-plus fa-fw",
                                        staticStyle: { "margin-left": "10px" }
                                      })
                                    ]
                                  ),
                              _vm._v(" "),
                              _vm.hasMultipleDeliverableTemplate
                                ? _c(
                                    "div",
                                    { staticClass: "dropdown-menu" },
                                    _vm._l(
                                      _vm.newDeliverableTemplates,
                                      function(type, i) {
                                        return _c(
                                          "a",
                                          {
                                            key: i,
                                            staticClass: "dropdown-item",
                                            on: {
                                              click: function($event) {
                                                $event.preventDefault()
                                                return _vm.createDeliverableTemplateDropdownClick(
                                                  type
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(_vm._s(type.title))]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e()
                            ])
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", { staticClass: "ml-2" }, [_c("FeedbackBtn")], 1)
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.isFilterActive()
              ? _c(
                  "div",
                  { staticClass: "mt-3 filter-badges" },
                  [
                    _c("label", { staticClass: "remove-filter-text" }, [
                      _vm._v("Click to remove filters:")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "badge badge-primary mr-2 mb-2",
                        style: { cursor: "pointer" },
                        on: {
                          click: function($event) {
                            _vm.filterQuery.query = null
                            _vm.searchQuery = ""
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.filterQuery.query))]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.status, function(status) {
                      return _vm.$router.currentRoute.name != "globalSearch"
                        ? _c(
                            "span",
                            {
                              staticClass: "badge mr-2 mb-2",
                              style: {
                                cursor: "pointer",
                                color: "var(--wf-secondary)",
                                backgroundColor: status.color
                              },
                              on: {
                                click: function($event) {
                                  return _vm.removeFilter(status)
                                }
                              }
                            },
                            [_vm._v(_vm._s(status.name))]
                          )
                        : _vm._e()
                    }),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch"
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartStatus")
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.filterQuery.status[0]))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name == "globalSearch" &&
                    _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetDepartTagSort")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.sort == "usedDesc"
                                  ? "Frequency Descending"
                                  : "Frequency Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.priorityFilter > 0
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("resetPriorityFilter")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Priority " +
                                _vm._s(_vm.filterQuery.priorityFilter)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.$router.currentRoute.name != "globalSearch" &&
                    _vm.filterQuery.sort
                      ? _c(
                          "span",
                          {
                            staticClass:
                              "badge mr-2 mb-2 bg-primary cursor-pointer",
                            staticStyle: { color: "var(--wf-secondary)" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter(
                                  "resetDeliverableTemplateSort"
                                )
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.filterQuery.sort == "priorityDesc"
                                  ? "Priority Descending"
                                  : "Priority Ascending"
                              )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.outlet, function(outlet) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(outlet)
                            }
                          }
                        },
                        [_vm._v(_vm._s(outlet.name))]
                      )
                    }),
                    _vm._v(" "),
                    Array.isArray(_vm.filterQuery.deliverableTemplate)
                      ? _c(
                          "span",
                          _vm._l(_vm.filterQuery.deliverableTemplate, function(
                            deliverableTemplate
                          ) {
                            return _c(
                              "span",
                              {
                                staticClass: "badge badge-primary mr-2 mb-2",
                                style: { cursor: "pointer" },
                                on: {
                                  click: function($event) {
                                    return _vm.removeFilter(deliverableTemplate)
                                  }
                                }
                              },
                              [_vm._v(_vm._s(deliverableTemplate.name))]
                            )
                          }),
                          0
                        )
                      : typeof _vm.filterQuery.deliverableTemplate !=
                        "undefined"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("deliverableTemplate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.filterQuery.deliverableTemplate.name)
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.coordinator, function(coordinator) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(coordinator)
                            }
                          }
                        },
                        [_vm._v(_vm._s(coordinator.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(_vm.dueDateLabel) +
                                ": " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByTaskDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByTaskDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Task Due Date: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.taskDateRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.taskDateRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterNoDueDate == 1
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.filterNoDueDate = false
                              }
                            }
                          },
                          [_vm._v("No " + _vm._s(_vm.dueDateLabel))]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterNoTaskDueDate == 1
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.filterNoTaskDueDate = false
                              }
                            }
                          },
                          [_vm._v("No Task Due Date")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCreated
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCreated")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Created: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCreatedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByDateCompleted
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByDateCompleted")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Completed: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange
                                      .startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.dateCompletedRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.filterByPublishDate
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("filterByPublishDate")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "Date to Post: " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.datePublishRange.startDate,
                                    "MMM DD"
                                  )
                                ) +
                                " - " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.filterQuery.datePublishRange.endDate,
                                    "MMM DD"
                                  )
                                )
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.tag, function(tag) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(tag)
                            }
                          }
                        },
                        [_vm._v(_vm._s(tag.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.department, function(department) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(department)
                            }
                          }
                        },
                        [_vm._v(_vm._s(department.name))]
                      )
                    }),
                    _vm._v(" "),
                    _vm._l(_vm.filterQuery.project, function(project) {
                      return _c(
                        "span",
                        {
                          staticClass: "badge badge-primary mr-2 mb-2",
                          style: { cursor: "pointer" },
                          on: {
                            click: function($event) {
                              return _vm.removeFilter(project)
                            }
                          }
                        },
                        [_vm._v(_vm._s(project.title))]
                      )
                    }),
                    _vm._v(" "),
                    _vm.filterQuery.noDepartment == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noDepartment = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Department")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.noOutlet == "accepted"
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                _vm.filterQuery.noOutlet = "not_accepted"
                              }
                            }
                          },
                          [_vm._v("No Outlet")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.overdue
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("overdue")
                              }
                            }
                          },
                          [_vm._v("overdue")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.today
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("today")
                              }
                            }
                          },
                          [_vm._v("today")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.thisWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("thisWeek")
                              }
                            }
                          },
                          [_vm._v("this week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.nextWeek
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("nextWeek")
                              }
                            }
                          },
                          [_vm._v("next week")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.upcoming
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("upcoming")
                              }
                            }
                          },
                          [_vm._v("upcoming")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.filterQuery.weekFilterOptions.noDeadline
                      ? _c(
                          "span",
                          {
                            staticClass: "badge badge-primary mr-2 mb-2",
                            style: { cursor: "pointer" },
                            on: {
                              click: function($event) {
                                return _vm.removeFilter("noDeadline")
                              }
                            }
                          },
                          [_vm._v("no deadline")]
                        )
                      : _vm._e()
                  ],
                  2
                )
              : _vm._e()
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "col-sm-5 col-md-4 col-4 text-right right-side" },
            [
              _c(
                "div",
                { staticClass: "logo-user" },
                [
                  _c("HeaderNotification"),
                  _vm._v(" "),
                  _c("LoggedInUser"),
                  _vm._v(" "),
                  _c("Logo")
                ],
                1
              )
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "input-group-text" }, [
      _c("i", { staticClass: "fas fa-search" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }